import { CheckIcon, MinusIcon } from "@heroicons/react/24/outline";
import CustomButton from "./CustomButton";
import { useNavigate } from "react-router-dom";

export const CompareSelectedVendors = ({
  handleSelectAllCards,
  allCardsSelected,
  listSelectedVendors,
  onRemove,
}) => {
  const navigate = useNavigate();
  const renderCompareButton = () => (
    <>
      {listSelectedVendors.length > 0 && (
        <CustomButton
          color={"bg-indigo-600"}
          size={"text-base"}
          weight={"font-normal"}
          height={"h-9"}
          width={"w-[82px]"}
          textColor={"text-white"}
          text={"Compare"}
          onClick={() => {
            navigate("/TrialExperience");
          }}
        />
      )}
    </>
  );

  // Render selected vendor badges for list view selection
  const renderListSelectedBadges = () => (
    <div className="flex items-center gap-2 flex-nowrap">
      {listSelectedVendors.map((v) => (
        <span
          key={v.name}
          className="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium bg-indigo-600 text-white ring-1 ring-indigo-600 flex-shrink-0 whitespace-nowrap"
        >
          {v.name}
          <button
            type="button"
            className="group relative -mr-1 h-3.5 w-3.5 rounded-sm hover:bg-indigo-800/20 ml-1"
            onClick={() => onRemove(v)}
          >
            <span className="sr-only">Remove {v.name}</span>
            <svg viewBox="0 0 14 14" className="h-3.5 w-3.5 stroke-current">
              <path d="M4 4l6 6m0-6l-6 6" />
            </svg>
          </button>
        </span>
      ))}
    </div>
  );
  return (
    <>
      <button
        type="button"
        onClick={handleSelectAllCards}
        className="inline-flex items-center gap-2 rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-700 shadow-sm hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 flex-shrink-0"
      >
        {allCardsSelected ? (
          <MinusIcon className="h-4 w-4 text-gray-500" aria-hidden="true" />
        ) : (
          <CheckIcon className="h-4 w-4 text-gray-500" aria-hidden="true" />
        )}
        {allCardsSelected ? "Deselect All" : "Select All"}
      </button>

      {/* Compare button - fixed position */}
      {renderCompareButton()}

      {/* Scrollable badges container with fixed height to prevent shifting */}
      {listSelectedVendors.length > 0 && (
        <div className="flex-1 min-w-0 overflow-x-auto h-[40px] flex items-center">
          {renderListSelectedBadges()}
        </div>
      )}
      
        {listSelectedVendors.length === 0 && <div className="flex-1" />}
    </>
  );
};
